import { render } from "./save.html?vue&type=template&id=35fe382e&scoped=true&external"
import script from "./save.vue?vue&type=script&lang=js"
export * from "./save.vue?vue&type=script&lang=js"

import "./save.vue?vue&type=style&index=0&id=35fe382e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fe382e"]])

export default __exports__